<template>
  <CCard class="mb-3">
    <CCardHeader>Envios programados vs manuales</CCardHeader>
    <CCardBody>
      <CRow>
        <CCol md="4" class="mb-3">
          <div class="small text-muted mb-2">Participacion de envios</div>
          <apexchart
            type="donut"
            height="280"
            :options="donutOptions"
            :series="donutSeries"
          />
        </CCol>
        <CCol md="8" class="mb-3">
          <div class="small text-muted mb-2">Comparativo de tasas</div>
          <apexchart
            type="bar"
            height="280"
            :options="barsOptions"
            :series="barsSeries"
          />
        </CCol>
      </CRow>
    </CCardBody>
  </CCard>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'ScheduledVsManualCard',
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    rows: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    labels() {
      return this.rows.map(function (row) {
        return row.label || 'N/D'
      })
    },
    donutSeries() {
      return this.rows.map(function (row) {
        return Number(row && row.sent_count ? row.sent_count : 0)
      })
    },
    donutOptions() {
      return {
        labels: this.labels,
        colors: ['#8AA1B1', '#B59B6A'],
        legend: {
          position: 'bottom',
        },
        dataLabels: {
          formatter: function (value) {
            return value.toFixed(1) + '%'
          },
        },
      }
    },
    barsSeries() {
      const self = this
      const asPct = function (key) {
        return self.rows.map(function (row) {
          return Number(row && row[key] ? row[key] : 0) * 100
        })
      }

      return [
        { name: 'Entrega', data: asPct('delivery_rate') },
        { name: 'Lectura', data: asPct('read_rate') },
        { name: 'Respuesta', data: asPct('response_rate') },
        { name: 'Error', data: asPct('error_rate') },
      ]
    },
    barsOptions() {
      return {
        chart: {
          toolbar: { show: false },
          foreColor: '#5c5648',
        },
        colors: ['#8EB69B', '#7F95D1', '#C9A66B', '#D97D7D'],
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 4,
            columnWidth: '55%',
          },
        },
        dataLabels: { enabled: false },
        xaxis: {
          categories: this.labels,
        },
        yaxis: {
          max: 100,
          labels: {
            formatter: function (value) {
              return value.toFixed(0) + '%'
            },
          },
        },
        tooltip: {
          y: {
            formatter: function (value) {
              return value.toFixed(1) + '%'
            },
          },
        },
        legend: {
          position: 'top',
        },
        grid: {
          borderColor: '#ece7d8',
        },
      }
    },
  },
}
</script>
